import React from 'react';
import { motion } from 'framer-motion';
interface SectionShellProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  align?: 'center' | 'left';
}
export function SectionShell({
  id,
  eyebrow,
  title,
  subtitle,
  children,
  className = '',
  align = 'center'
}: SectionShellProps) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return <section id={id} className={`relative py-14 sm:py-24 lg:py-28 ${className}`} data-id="element-223" data-mp="2n5mu9irxzv4q">
      <div className="container" data-id="element-224" data-mp="2963k6kfkm9ps">
        {(eyebrow || title || subtitle) && <motion.header initial={{
        opacity: 0,
        y: 28
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className={`mx-auto flex max-w-3xl flex-col ${alignment} ${align === 'center' ? 'mb-9 sm:mb-14' : 'mb-8 sm:mb-12'}`} data-id="element-225" data-mp="2986li0m6bp9t">
            {eyebrow && <span className="mb-4 inline-flex items-center gap-2.5 rounded-full border border-gold-500/30 bg-gold-500/[0.06] px-4 py-1.5 text-[11px] font-semibold uppercase tracking-widest2 text-gold-400 sm:mb-5" data-id="element-226" data-mp="1y2inz719nzeg">
                {eyebrow}
              </span>}
            {title && <h2 className="font-display text-3xl font-bold leading-[1.12] text-cream sm:text-4xl lg:text-[2.9rem]" data-id="element-227" data-mp="1j46sv4tjkype">
                {title}
              </h2>}
            {subtitle && <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-cream/60 sm:mt-5 sm:text-lg" data-id="element-228" data-mp="1t3fkvs4uk394">
                {subtitle}
              </p>}
          </motion.header>}
        {children}
      </div>
    </section>;
}